<ion-app mode="md">
  @if (authService.initializationFailed) {
    <ion-content>
      <div
        class="flexed"
        style="height: 100%; justify-content: center; align-items: center"
      >
        <ion-card
          role="alert"
          style="max-width: 560px; margin: 24px; padding: 20px; text-align: center"
        >
          <h1>Unable to load your dashboard</h1>
          <p>Your session is still active. Try again in a moment.</p>
          <ion-button (click)="authService.retryInitialization()">Try again</ion-button>
        </ion-card>
      </div>
    </ion-content>
  }
  <ion-content *ngIf="!authService.initializationFailed && authService.accountStatus === 'inactive'">
    <div
      class="flexed"
      style="height: 100%; justify-content: center; align-items: center"
    >
      <ion-card style="width: 50%; padding: 20px; font-size: 18px">
        Your organization's account has been deactivated. If you believe this is
        a mistake or you would like to reactivate the account, reach out to us
        at
        <a href="mailto:help@unthread.io">help&#64;unthread.io</a>.
      </ion-card>
    </div>
  </ion-content>
  <ng-container
    *ngIf="!authService.initializationFailed && (authService.accountStatus !== 'inactive' || authService.canBypassRestrictions())"
  >
    <ng-container *ngIf="!authService.isEmailVerified && !isPasswordSetupPage">
      <ion-content>
        <div
          class="flexed"
          style="
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          "
        >
          <ion-card
            style="
              max-width: 560px;
              padding: 20px;
              font-size: 18px;
              text-align: center;
            "
          >
            <ion-icon
              name="mail-unread-outline"
              style="font-size: 4.2rem; opacity: 0.7; margin-top: 20px"
            ></ion-icon>
            <h1>Set your password</h1>
            Request a setup email, then open it to choose your password. Reach out to
            <a href="mailto:help@unthread.io">help&#64;unthread.io</a> with any
            questions.
            <div style="margin-top: 20px">
              <ion-button (click)="returnToLogin()" fill="clear"
                >Return to login page</ion-button
              ><br />
              <ion-button (click)="sendPasswordSetupEmail()" fill="clear"
                >Send password setup email</ion-button
              >
            </div>
          </ion-card>
        </div>
      </ion-content>
    </ng-container>

    <ng-container *ngIf="authService.isEmailVerified || isPasswordSetupPage">
      <ion-header [hidden]="hideNavBar || isPasswordSetupPage">
        <ion-toolbar class="nav-toolbar">
          <div class="nav-header">
            <div class="flexed">
              <ion-menu-toggle id="main-content">
                <ion-button
                  shape="round"
                  fill="clear"
                  color="dark"
                  class="menu-toggle-button"
                >
                  <ion-icon name="menu-outline"></ion-icon>
                </ion-button>
              </ion-menu-toggle>
              <a
                (click)="navigateToHome()"
                class="logo-wrapper"
                style="cursor: pointer"
              >
                <img
                  src="{{ environment.assetsBaseUrl + '/icons/icon.svg' }}"
                  class="logo"
                />
                <div
                  *ngIf="authService.tenant?.name"
                  class="project-selector hidden-mobile"
                >
                  <span class="nav-title">{{ authService.tenant.name }}</span>
                </div>
              </a>
              <span
                *ngIf="
                  showProjectSelector &&
                  authService.tenant?.name &&
                  authService.nonTemplateProjects?.length
                "
                class="nav-icon hidden-mobile"
                style="
                  margin: 0 4px;
                  opacity: 0.5;
                  align-self: center;
                  font-size: 0.6rem;
                "
                aria-hidden="true"
                >/</span
              >
              <div
                *ngIf="showProjectSelector && authService.nonTemplateProjects?.length"
                class="project-selector project-selector-clickable"
                [ngClass]="{ 'selected-project': authService.selectedProject }"
                (click)="showProjectOptions()"
                [ngxTippy]="
                  authService.selectedProject
                    ? 'Click to switch projects'
                    : '<strong>Viewing all projects</strong><br>Click to switch a specific project'
                "
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom',
                  allowHTML: true
                }"
              >
                <img
                  *ngIf="authService.selectedProject?.supportLogo"
                  src="{{ authService.selectedProject?.supportLogo }}"
                  style="
                    width: 17px;
                    height: 17px;
                    border-radius: 5px;
                    margin-right: 7px;
                  "
                />
                <!-- If a project is selected, but it doesn't have a supportLogo, show a folder icon with a border -->
                <ion-icon
                  *ngIf="
                    authService.selectedProject &&
                    !authService.selectedProject.supportLogo
                  "
                  name="custom-project"
                  style="
                    border: 1px solid var(--ion-color-step-100);
                    border-radius: 5px;
                    margin-right: 7px;
                    padding: 3px;
                    color: var(--ion-color-step-600);
                    font-size: 0.75rem;
                  "
                ></ion-icon>
                <span class="nav-title">{{
                  authService.selectedProject?.name || "All Projects"
                }}</span>
                <ion-icon
                  name="custom-expand"
                  class="nav-icon"
                  style="
                    opacity: 0.75;
                    font-size: 0.75rem;
                    margin-top: 3px;
                    margin-left: 5px;
                  "
                ></ion-icon>
              </div>
              <!-- <div
                *ngIf="!showProjectSelector && authService.isTenantAdmin"
                class="project-selector project-selector-clickable"
                (click)="showAccountOptions()"
              >
                <ion-icon name="chevron-down-outline"></ion-icon>
              </div> -->
              <div *ngIf="isSuperAdmin" class="hidden-mobile">
                <a
                  class="nav-link"
                  routerDirection="root"
                  routerLink="super-admin"
                >
                  <ion-icon name="skull" class="nav-icon"></ion-icon>
                  <span class="nav-title">Super Admin</span>
                </a>
              </div>
              <ion-button
                [routerLink]="'/upgrade'"
                routerDirection="root"
                style="margin-right: 8px"
                [color]="trialExpired ? 'danger' : 'primary'"
                fill="clear"
                *ngIf="trialStatus"
                ngxTippy
                [disabled]="!authService.isTenantAdmin"
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom'
                }"
                data-tippy-content="Click to upgrade"
                class="hidden-sm nav-button hidden-mobile"
              >
                {{ trialStatus }}
              </ion-button>
            </div>
            <div class="flexed-align-center">
              <div
                class="command-bar-search-container"
                *ngIf="authService.user"
              >
                <div class="command-bar-search" (click)="openCommandBar()">
                  <ion-icon
                    name="search-outline"
                    class="search-icon"
                  ></ion-icon>
                  <span class="search-placeholder hidden-sm"
                    >Search or run command...</span
                  >
                  <div class="search-shortcut hidden-mobile">
                    <span class="shortcut-key">{{ commandBarShortcut }}</span>
                  </div>
                </div>
              </div>
              <ion-button
                [routerLink]="'/upgrade'"
                routerDirection="root"
                class="nav-button"
                color="success"
                style="margin-right: 8px; height: 27px"
                *ngIf="
                  trialStatus && authService.isTenantAdmin && !trialExpired
                "
              >
                <ion-icon
                  name="diamond-outline"
                  class="padded-icon button-icon"
                ></ion-icon>
                Upgrade
              </ion-button>
              <ion-button
                class="icon-button nav-button"
                color="dark"
                fill="clear"
                (click)="showCreateOptions()"
                *ngIf="authService.user"
                id="global-create-btn"
              >
                <ion-icon
                  name="add-circle"
                  style="font-size: 1.3rem"
                ></ion-icon>
              </ion-button>
              @if (canQuickCompose) {
                <ion-button
                  class="icon-button nav-button"
                  color="dark"
                  fill="clear"
                  (click)="showQuickComposeOptions()"
                  id="global-quick-compose-btn"
                  ngxTippy
                  [tippyProps]="{
                    touch: false,
                    arrow: false,
                    placement: 'bottom',
                    trigger: 'mouseenter'
                  }"
                  data-tippy-content="Quick compose"
                >
                  <ion-icon name="create-outline"></ion-icon>
                </ion-button>
              }

              <ion-button
                (click)="openGiftOptions()"
                class="icon-button hidden-sm nav-button"
                fill="clear"
                color="dark"
                detail="false"
                *ngIf="authService.user"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  trigger: 'mouseenter'
                }"
                data-tippy-content="Stuff just for you"
              >
                <ion-icon name="gift-outline"></ion-icon>
              </ion-button>
              <ion-button
                (click)="openNotifications()"
                class="icon-button nav-button"
                fill="clear"
                color="dark"
                detail="false"
                *ngIf="authService.user"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  trigger: 'mouseenter'
                }"
                data-tippy-content="Notifications"
              >
                <ion-icon
                  [name]="
                    unreadNotifications
                      ? 'notifications'
                      : 'notifications-outline'
                  "
                ></ion-icon>
                <span
                  class="notifications-bubble"
                  *ngIf="unreadNotifications"
                  >{{ unreadNotifications }}</span
                >
              </ion-button>
              <ion-button
                fill="clear"
                (click)="loginOrSignup()"
                *ngIf="!authService.user"
              >
                Log in or sign up
              </ion-button>
              <ion-button
                fill="clear"
                color="dark"
                (click)="openProfile()"
                *ngIf="authService.user"
                class="hidden-mobile nav-button"
                style="margin: 0"
              >
                <app-avatar
                  size="23"
                  [style.width]="'23px'"
                  [style.height]="'23px'"
                  [name]="authService.profile?.name ?? authService.user.displayName"
                  [image]="authService.userPhoto"
                >
                </app-avatar>
                <span class="hidden-xl text-with-left-icon">{{
                  authService.profile?.name ?? authService.user.displayName
                }}</span>
              </ion-button>
            </div>
          </div>
        </ion-toolbar>
        <!-- <ion-toolbar *ngIf="trialExpired">
          <div class="upgrade-feature-banner">
            <p style="margin-top: 0; font-weight: 700">Your trial has expired</p>
            <ion-button
              fill="outline"
              color="light"
              class="btn-small"
              shape="round"
              [routerLink]="'/upgrade'"
              *ngIf="authService.isTenantAdmin"
            >
              <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
              Upgrade account
            </ion-button>
            <ion-button
              fill="outline"
              color="light"
              class="btn-small"
              shape="round"
              href="mailto:sales@unthread.io"
              *ngIf="authService.isTenantAdmin"
            >
              Talk to sales
            </ion-button>
          </div>
        </ion-toolbar> -->
      </ion-header>
      <ion-content [scrollY]="false">
        <div class="content-wrapper" [class.copilot-open]="showCopilot">
          <ion-router-outlet id="main-content"></ion-router-outlet>

          <app-assistant-sidebar
            [isOpen]="showCopilot"
            [width]="366"
            sidebarTitle="Tailor"
            [showTitle]="!!copilotPanel?.conversationHistory?.length"
            [showNewChat]="!!copilotPanel?.conversationHistory?.length"
            [showCancel]="!!copilotPanel?.isLoading"
            (sidebarClose)="showCopilot = false"
            (newChatClick)="copilotPanel?.onNewChat()"
            (cancelClick)="copilotPanel?.onCancelRequest()"
          >
            <app-copilot-panel
              [isOpen]="showCopilot"
              (panelClose)="showCopilot = false"
            ></app-copilot-panel>
          </app-assistant-sidebar>
        </div>

        @if (authService.user) {
          <button
            type="button"
            class="copilot-expand-fab"
            [class.copilot-expand-fab--visible]="!showCopilot"
            (click)="expandCopilot()"
            aria-label="Open Tailor"
            [attr.aria-hidden]="showCopilot"
            ngxTippy
            data-tippy-content="Open Tailor, your AI assistant"
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'left',
              trigger: 'mouseenter'
            }"
          >
            <ion-icon [src]="'assets/custom-ion-icons/custom-tailor.svg'"></ion-icon>
            @if (copilotNotifications.badgeCount$ | async; as copilotBadgeCount) {
              <span class="copilot-expand-fab__badge" [attr.aria-label]="copilotBadgeCount + ' new from Tailor'">{{
                copilotBadgeCount
              }}</span>
            }
          </button>
        }
      </ion-content>
      <ion-footer
        [hidden]="hideNavBar || !authService.user"
        class="shown-mobile"
      >
        <ion-toolbar *ngIf="authService.user">
          <div class="nav-header">
            <a
              *ngFor="let p of appPages; let i = index"
              class="nav-link"
              routerDirection="root"
              [routerLink]="[p.url]"
              routerLinkActive="selected"
              #rla="routerLinkActive"
            >
              <ion-icon
                [name]="rla.isActive ? p.icon : p.icon + '-outline'"
                class="nav-icon"
              ></ion-icon>
              <span class="nav-title">{{ p.title }}</span>
              <ion-icon
                *ngIf="p.private"
                name="lock-closed-outline"
                class="padded-icon-left hidden-xl"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom'
                }"
                data-tippy-content="Only visible to admins"
              ></ion-icon>
            </a>
            <a
              class="nav-link"
              routerDirection="root"
              [routerLink]="'/profile'"
              routerLinkActive="selected"
              #rla="routerLinkActive"
            >
              <div class="profile-photo">
                <app-avatar
                  [size]="36"
                  [name]="authService.profile?.name ?? authService.user.displayName"
                  [image]="authService.userPhoto"
                >
                </app-avatar>
              </div>
            </a>
          </div>
        </ion-toolbar>
      </ion-footer>
    </ng-container>
  </ng-container>

  @if (!authService.initializationFailed) {
    <app-custom-command-bar></app-custom-command-bar>
  }
</ion-app>
